export const contactSchema = `
            emailAddress
            phone {
                diallingCode
                phoneNumber
            }
            address {
                city
                country
                postcode
                address
            }
    `;
